import { defineVideoTemplate } from "@assets/templates/builders";
import { BASE_ASSETS } from "@assets/templates/constants";

export const buildingFireExample = defineVideoTemplate({
  slug: "building-fire-example",
  title: "Firefighting",
  description: "Action timing",
  poster: BASE_ASSETS.buildingFireVideoPoster,
  video: BASE_ASSETS.buildingFireVideo,
  prompt: "When does the firefighter begin extinguishing with water? Use the <clip> tag to specify clips.",
  annotationFormat: "clip",
  enableThinking: true,
  temperature: 0,
});
